import { Component } from '@verndale/core';

class TagsRow extends Component {
  // eslint-disable-next-line no-useless-constructor
  constructor(el) {
    super(el);
  }

  setupDefaults() {
    this.dom = {
      el: this.el,
      printDropdown: this.el.querySelector('.boat-header__print-dropdown'),
      shareBtn: this.el.querySelector('.boat-header__share'),
      printBtn: this.el.querySelector('.boat-header__print'),
      boatHeaderTitle: document.querySelector('.boat-header__title'),
      toastElement: document.querySelector('#toast'),
      viewItem: this.el.querySelector('.tags-row__item-view'),
      listedItem: this.el.querySelector('.tags-row__item-listed'),
      tagsRowItemContainer: this.el.querySelector('.tags-row__item-container'),
    };

    this.handleHideTagsRow();
  }

  addListeners() {
    this.dom.shareBtn.addEventListener('click', this.handleShareClick.bind(this));
    this.dom.printBtn.addEventListener('click', this.handlePrintClick.bind(this));
    this.dom.printDropdown.addEventListener(
      'mouseleave',
      this.handleCloseDropdown.bind(this)
    );
    document.addEventListener('click', this.handleClickOutside.bind(this));
  }

  handleHideTagsRow() {
    if (this.dom.tagsRowItemContainer) {
      if (!this.dom.listedItem && !this.dom.viewItem) {
        this.dom.el.classList.add('hide');
      }
    }
  }

  handleShareClick() {
    const urlToShare = window.location.href.split('?')[0];

    if (navigator.share) {
      navigator
        .share({
          title: document.title,
          text: this.dom.boatHeaderTitle.textContent || '',
          url: urlToShare
        })
        .then(() => console.log('Successful share'))
        .catch(error => console.log('Error sharing', error));
    } else {
      navigator.clipboard.writeText(urlToShare);
      this.dom.toastElement?.classList.add('show');
      setTimeout(() => {
        this.dom.toastElement?.classList.remove('show');
      }, 3000);
    }
  }

  handleClickOutside(e) {
    const {target} = e;
    if (target !== this.dom.printBtn) {
      this.dom.printDropdown.classList.remove('show');
    }
  }

  handleCloseDropdown(e) {
    const {target} = e;
    target.classList.remove('show');
  }

  handlePrintClick() {
    this.dom.printDropdown.classList.toggle('show');
  }
}

export default TagsRow;
